import React from "react";
import { Link, useNavigate } from "react-router-dom";

const ErrorPage = () => {
  return (
    <section id="content" className="content">
      <div className="content__boxed card rounded-0 w-100 min-vh-100 d-flex flex-column align-items-stretch justify-content-center">
        <div className="content__wrap">
          <div className="text-center">
            {/* <div className="error-code page-title mb-3">500</div> */}
            <h3 className="mb-4">
              <div className="badge bg-danger">Internal Server Error !</div>
            </h3>
            <p className="lead">
              Something went wrong and server couldn't process your request.
            </p>
          </div>

          <div className="d-flex justify-content-center gap-3 mt-4">
            <Link to={-1} className="btn btn-light">
              Go back
            </Link>
            <Link to="/dashboard" className="btn btn-primary">
              Return home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
